import React from 'react'

function Self_Mark_Attendance() {
  return (
    <div>
      <div className="container-fluid">
        <div className="page-head">
          <div>
            <h2>Self Mark Attendance</h2>
            <p>Thursday, 24 April 2026 &nbsp;·&nbsp; Delhi Tech Hub &nbsp;·&nbsp; TCS – Cloud Transformation</p>
          </div>
          <div className="head-actions">
            <button className="btn-og btn-og-secondary btn-og-sm" onclick="ogOpenModal('regulariseModal')">
              <i className="fa fa-calendar-plus-o"></i>  Apply for Leave
            </button>
            <button className="btn-og btn-og-secondary btn-og-sm" onclick="ogOpenModal('regulariseModal')">
              <i className="fa fa-file-pdf-o"></i>  Download Monthly Report
            </button>
            <button className="btn-og theme-color btn-og-sm" onclick="ogOpenModal('regulariseModal')">
              <i className="fa fa-edit"></i> Request Regularization
            </button>
            <a href="my-attendance.html">
              <button className="btn-og btn-og-outline btn-og-sm">
                <i className="fa fa-calendar-check-o"></i> View My Attendance
              </button>
            </a>
          </div>
        </div>

        <div className="self-mark-attendance-body">
          <div className="quick-stats-row">
            <div className="qs-card">
              <div className="qs-icon" style={{ background: '#dcfce7', color: '#16a34a' }}><i className="fa fa-check-circle"></i></div>
              <div>
                <div className="qs-label">Present Days</div>
                <div className="qs-value">22</div>
                <div className="qs-sub">This month (Apr)</div>
              </div>
            </div>
            <div className="qs-card">
              <div className="qs-icon" style={{ background: '#fef3c7', color: '#d97706' }}><i className="fa fa-clock-o"></i></div>
              <div>
                <div className="qs-label">Avg Check-In</div>
                <div className="qs-value">09:04</div>
                <div className="qs-sub">April average</div>
              </div>
            </div>
            <div className="qs-card">
              <div className="qs-icon" style={{ background: '#ede9fe', color: '#6d28d9' }}><i className="fa fa-home"></i></div>
              <div>
                <div className="qs-label">WFH Days</div>
                <div className="qs-value">3</div>
                <div className="qs-sub">This month</div>
              </div>
            </div>
            <div className="qs-card">
              <div className="qs-icon" style={{ background: '#fdf0ec', color: 'var(--primary)' }}><i className="fa fa-trophy"></i></div>
              <div>
                <div className="qs-label">Attendance</div>
                <div className="qs-value" style={{ color: '#16a34a' }}>96%</div>
                <div className="qs-sub">Above target (90%)</div>
              </div>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: '1.25rem', alignItems: 'start' }}>
            <div>

              <div className="mark-hero">
                <div className="mark-hero-top">
                  <div className="mark-hero-greeting">Good morning 👋</div>
                  <div className="mark-hero-name">Rahul Singh</div>
                  <div className="mark-hero-sub">Engineering Lead &nbsp;·&nbsp; Employee ID: OG-10245</div>
                  <div className="mark-hero-clock">
                    <div className="mark-hero-time" id="liveClock">09:02 AM</div>
                    <div className="mark-hero-date" id="liveDate">Thursday, 24 April 2026</div>
                  </div>
                </div>

                <div className="mark-action-float">

                  <div className="work-type-tabs" id="workTypeTabs">
                    <button className="wt-tab active" id="wtOffice" onclick="setWorkType('office')">
                      <i className="fa fa-building"></i> Office
                    </button>
                    <button className="wt-tab" id="wtWfh" onclick="setWorkType('wfh')">
                      <i className="fa fa-home"></i> Work From Home
                    </button>
                    <button className="wt-tab" id="wtClient" onclick="setWorkType('client')">
                      <i className="fa fa-briefcase"></i> Client Site
                    </button>
                    <button className="wt-tab" id="wtTravel" onclick="setWorkType('travel')">
                      <i className="fa fa-plane"></i> On Travel
                    </button>
                  </div>

                  <div className="mark-status-row">
                    <div>
                      <div className="mark-status-label">Today's Status</div>
                      <span className="mark-status-badge msb-not-marked" id="todayStatusBadge">
                        <i className="fa fa-clock-o"></i> Not Marked
                      </span>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div className="mark-status-label">Shift</div>
                      <div style={{ fontWeight: '700', fontSize: '.85rem' }}>09:00 AM – 06:00 PM</div>
                      <div style={{ fontSize: '.68rem', color: 'var(--text-muted)' }}>Standard Shift</div>
                    </div>
                  </div>

                    <div className="form-group" style={{ gridColumn: '1/-1' }}>
                      <label className="og-label">Employee <span className="req">*</span></label>
                      <select className="og-select">
                        <option>— Select Employee —</option>
                        <option value="OG-10245">Rahul Singh (OG-10245)</option>
                        <option value="OG-10246">Priya Sharma (OG-10246)</option>
                        <option value="OG-10247">Amit Verma (OG-10247)</option>

                      </select>
                    </div>
                  <div className="geo-bar geo-loading" id="geoBar">
                    <div className="geo-dot"></div>
                    <div>
                      <div id="geoText">Detecting your location…</div>
                      <div id="geoSub" style={{ fontSize: '.68rem', fontWeight: '400', opacity: '.7', marginTop: '.08rem' }}></div>
                    </div>
                    <div className="geo-right" id="geoRight"></div>
                  </div>

                  <div className="checkin-out-grid">
                    <div className="time-block" id="checkInBlock">
                      <div className="time-block-icon tbi-in"><i className="fa fa-sign-in"></i></div>
                      <div className="time-block-label">Check In</div>
                      <div className="time-block-value empty" id="checkInVal">—&nbsp;:&nbsp;—</div>
                      <div className="time-block-geo" id="checkInGeo"><i className="fa fa-map-marker"></i> Waiting for mark</div>
                    </div>
                    <div className="time-block" id="checkOutBlock">
                      <div className="time-block-icon tbi-out"><i className="fa fa-sign-out"></i></div>
                      <div className="time-block-label">Check Out</div>
                      <div className="time-block-value empty" id="checkOutVal">—&nbsp;:&nbsp;—</div>
                      <div className="time-block-geo" id="checkOutGeo"><i className="fa fa-map-marker"></i> Not checked out</div>
                    </div>
                  </div>

                  <div className="break-row" id="breakRow" style={{ display: 'none' }}>
                    <div className="break-info">
                      <i className="fa fa-coffee"></i>
                      <span id="breakText">No break taken today</span>
                    </div>
                    <button className="btn-og btn-og-secondary btn-og-sm" id="breakBtn" onclick="toggleBreak()">
                      <i className="fa fa-pause"></i> Start Break
                    </button>
                  </div>

                  <div className="selfie-box" id="selfieBox" onclick="captureSelfie()">
                    <div id="selfiePreviewWrap">
                      <i className="fa fa-camera" id="selfieIcon"></i>
                    </div>
                    <div className="selfie-box-label" id="selfieLabel">Tap to capture selfie (optional)</div>
                  </div>

                  <div className="remark-box">
                    <label className="og-label">Remark / Note <span style={{ fontWeight: '400', color: 'var(--text-muted)' }}>(optional)</span></label>
                    <textarea className="og-textarea" id="remarkInput" rows="2" placeholder="e.g. Working from client campus today, internet was unstable…"></textarea>
                  </div>

                  <div className="punch-btn-wrap">
                    <button className="punch-btn punch-btn-checkin" id="punchBtn" onclick="handlePunch()">
                      <i className="fa fa-sign-in" id="punchIcon"></i>
                      <span className="punch-btn-text" id="punchText">CHECK IN</span>
                    </button>
                  </div>

                  <div style={{ textAlign: 'center', fontSize: '.72rem', color: 'var(--text-muted)', marginTop: '-.4rem' }} id="punchHint">
                    Press to mark your check-in time. Your location will be recorded.
                  </div>

                </div>
              </div>

              <div className="today-log" id="todayLog">
                <div className="today-log-header">
                  <h5><i className="fa fa-history" style={{ color: 'var(--primary)', marginRight: '.4rem' }}></i>Today's Activity Log</h5>
                  <span style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>24 Apr 2026</span>
                </div>
                <div className="log-timeline" id="logTimeline">

                  <div id="logEmpty" style={{ textAlign: 'center', padding: '1.5rem 1rem', color: 'var(--text-muted)' }}>
                    <i className="fa fa-list-ul" style={{ fontSize: '1.8rem', opacity: '.3', marginBottom: '.5rem', display: 'block' }}></i>
                    <div style={{ fontSize: '.8rem', fontWeight: '500' }}>No activity yet today.</div>
                    <div style={{ fontSize: '.73rem', marginTop: '.2rem' }}>Check in to start logging your attendance activity.</div>
                  </div>
                </div>
              </div>

              <div className="reg-note">
                <i className="fa fa-info-circle"></i>
                <div>
                  Missed marking attendance? Use <strong>Request Regularization</strong> to correct yesterday or past entries. You can submit up to <strong>3 requests/month</strong> — subject to manager approval.
                  <button className="btn-og btn-og-outline btn-og-xs" style={{ marginLeft: '.5rem' }} onclick="ogOpenModal('regulariseModal')">Regularise</button>
                </div>
              </div>

            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>

              <div className="og-card">
                <div className="og-card-header">
                  <h5><i className="fa fa-map-marker" style={{ color: 'var(--primary)', marginRight: '.4rem' }}></i>Location</h5>
                  <span className="status-pill pill-active" id="locPill"><span>●</span> Geo Verified</span>
                </div>
                <div className="og-card-body" style={{ paddingTop: '.85rem' }}>
                  <div className="mini-map">
                    <div className="mini-map-pin"><i className="fa fa-map-marker"></i></div>
                    <div className="mini-map-label" id="mapLocLabel">Delhi Tech Hub</div>
                    <div className="mini-map-sub" id="mapLocSub">Within geo-fence radius</div>
                  </div>
                  <div style={{ fontSize: '.77rem', color: 'var(--text-dark)', fontWeight: '600', marginBottom: '.2rem' }} id="locName">Delhi Tech Hub</div>
                  <div style={{ fontSize: '.72rem', color: 'var(--text-muted)' }} id="locAddr">Plot 7A, Sector 127, Noida – 201301</div>
                  <div style={{ marginTop: '.85rem', display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.75rem' }}>
                      <span style={{ color: 'var(--text-muted)' }}>Geo-fence Radius</span>
                      <span style={{ fontWeight: '600' }}>200 m</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.75rem' }}>
                      <span style={{ color: 'var(--text-muted)' }}>Your Distance</span>
                      <span style={{ fontWeight: '600', color: '#16a34a' }} id="geoDistance">~42 m</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.75rem' }}>
                      <span style={{ color: 'var(--text-muted)' }}>Accuracy</span>
                      <span style={{ fontWeight: '600' }} id="geoAccuracy">±15 m</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="og-card">
                <div className="og-card-header">
                  <h5><i className="fa fa-clock-o" style={{ color: 'var(--primary)', marginRight: '.4rem' }}></i>Shift Details</h5>
                </div>
                <div className="og-card-body" style={{ padding: '.85rem 1.25rem' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '.6rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>Shift</span>
                      <span style={{ fontSize: '.8rem', fontWeight: '700' }}>Standard Shift</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>Timing</span>
                      <span style={{ fontSize: '.8rem', fontWeight: '600' }}>09:00 AM – 06:00 PM</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>Grace Period</span>
                      <span style={{ fontSize: '.8rem', fontWeight: '600' }}>15 min</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>Late after</span>
                      <span style={{ fontSize: '.8rem', fontWeight: '600', color: '#d97706' }}>09:15 AM</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>Min. Work Hours</span>
                      <span style={{ fontSize: '.8rem', fontWeight: '600' }}>8h 00m</span>
                    </div>
                    <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '.6rem .75rem', marginTop: '.3rem' }}>
                      <div style={{ fontSize: '.68rem', color: 'var(--text-muted)', marginBottom: '.35rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '.4px' }}>Time to check-in deadline</div>
                      <div style={{ fontSize: '1.05rem', fontWeight: '800', color: 'var(--primary)' }} id="shiftCountdown">—</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="og-card">
                <div className="og-card-header">
                  <h5><i className="fa fa-bar-chart" style={{ color: 'var(--primary)', marginRight: '.4rem' }}></i>This Week</h5>
                  <span style={{ fontSize: '.73rem', color: 'var(--text-muted)' }}>Apr 20–26</span>
                </div>
                <div className="og-card-body" style={{ padding: '.9rem 1.25rem' }}>
                  <div style={{ display: 'flex', gap: '.4rem', alignItems: 'flex-end', marginBottom: '.85rem' }}>

                    <div style={{ flex: '1', textAlign: 'center' }}>
                      <div style={{ background: '#16a34a', borderRadius: '4px 4px 0 0', height: '54px', width: '100%' }}></div>
                      <div style={{ fontSize: '.65rem', color: 'var(--text-muted)', marginTop: '.25rem' }}>Mon</div>
                      <span className="att-badge att-badge-sm att-P" style={{ marginTop: '.15rem', width: 'auto', padding: '.1rem .3rem' }}>P</span>
                    </div>
                    <div style={{ flex: '1', textAlign: 'center' }}>
                      <div style={{ background: '#16a34a', borderRadius: '4px 4px 0 0', height: '50px', width: '100%' }}></div>
                      <div style={{ fontSize: '.65rem', color: 'var(--text-muted)', marginTop: '.25rem' }}>Tue</div>
                      <span className="att-badge att-badge-sm att-P" style={{ marginTop: '.15rem', width: 'auto', padding: '.1rem .3rem' }}>P</span>
                    </div>
                    <div style={{ flex: '1', textAlign: 'center' }}>
                      <div style={{ background: '#6366f1', borderRadius: '4px 4px 0 0', height: '52px', width: '100%' }}></div>
                      <div style={{ fontSize: '.65rem', color: 'var(--text-muted)', marginTop: '.25rem' }}>Wed</div>
                      <span className="att-badge att-badge-sm att-WFH" style={{ marginTop: '.15rem', width: 'auto', padding: '.1rem .3rem', fontSize: '.55rem' }}>WFH</span>
                    </div>
                    <div style={{ flex: '1', textAlign: 'center' }}>
                      <div style={{ background: '#fcd34d', borderRadius: '4px 4px 0 0', height: '28px', width: '100%', border: '2px dashed var(--primary)' }}></div>
                      <div style={{ fontSize: '.65rem', color: 'var(--primary)', fontWeight: '700', marginTop: '.25rem' }}>Thu</div>
                      <span className="att-badge att-badge-sm" style={{ marginTop: '.15rem', width: 'auto', padding: '.1rem .3rem', background: '#fef3c7', color: '#d97706', fontSize: '.55rem' }}>Today</span>
                    </div>
                    <div style={{ flex: '1', textAlign: 'center' }}>
                      <div style={{ background: '#e2e8f0', borderRadius: '4px 4px 0 0', height: '54px', width: '100%', opacity: '.4' }}></div>
                      <div style={{ fontSize: '.65rem', color: 'var(--text-muted)', marginTop: '.25rem' }}>Fri</div>
                      <span className="att-badge att-badge-sm att-em" style={{ marginTop: '.15rem', width: 'auto', padding: '.1rem .3rem' }}>·</span>
                    </div>
                    <div style={{ flex: '1', textAlign: 'center' }}>
                      <div style={{ background: '#f1f5f9', borderRadius: '4px 4px 0 0', height: '36px', width: '100%' }}></div>
                      <div style={{ fontSize: '.65rem', color: '#6366f1', marginTop: '.25rem' }}>Sat</div>
                      <span className="att-badge att-badge-sm att-WO" style={{ marginTop: '.15rem', width: 'auto', padding: '.1rem .3rem' }}>WO</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.75rem', color: 'var(--text-muted)' }}>
                    <span>Week Hours</span>
                    <strong style={{ color: 'var(--text-dark)' }}>26h 30m / 40h</strong>
                  </div>
                  <div style={{ background: '#f4f6f9', borderRadius: '20px', height: '7px', marginTop: '.4rem' }}>
                    <div style={{ background: 'var(--primary)', height: '7px', borderRadius: '20px', width: '66%' }}></div>
                  </div>
                </div>
              </div>

              <div className="og-card">
                <div className="og-card-header"><h5>Quick Actions</h5></div>
                <div className="og-card-body" style={{ display: 'flex', flexDirection: 'column', gap: '.5rem', padding: '.85rem 1.25rem' }}>
                  <button className="btn-og btn-og-outline" style={{ justifyContent: 'flex-start' }} onclick="ogOpenModal('regulariseModal')">
                    <i className="fa fa-edit" style={{ color: 'var(--primary)', width: '18px' }}></i> Request Regularization
                  </button>
                  <button className="btn-og btn-og-secondary" style={{ justifyContent: 'flex-start' }} onclick="ogToast('Opening leave application…','info')">
                    <i className="fa fa-calendar-plus-o" style={{ width: '18px' }}></i> Apply for Leave
                  </button>
                  <a href="my-attendance.html" style={{ textDecoration: 'none' }}>
                    <button className="btn-og btn-og-secondary" style={{ justifyContent: 'flex-start', width: '100%' }}>
                      <i className="fa fa-calendar-check-o" style={{ width: '18px' }}></i> View My Attendance
                    </button>
                  </a>
                  <button className="btn-og btn-og-secondary" style={{ justifyContent: 'flex-start' }} onclick="ogToast('Downloading attendance report…','info')">
                    <i className="fa fa-file-pdf-o" style={{ width: '18px' }}></i> Download Monthly Report
                  </button>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Self_Mark_Attendance